import FormHeading from "../en/form-heading-text.js";
export default FormHeading;
